export default async function PegaEvangelhoDia() {
	try {
		var url =
			"https://bomfa.azurewebsites.net/proxy.aspx?url=https://liturgia.cancaonova.com/pb/";

		const response = await fetch(url, { method: "GET" });

		if (!response.ok) {
			const message = `Erro ao pegar evangelho: ${response.status}`;
			throw new Error(message);
		}

		var body = await response.text();

		if (body.indexOf("[Error]") >= 0)
			throw new Error(`Error fetching URL ${url}`);

		var evangelho = GetValueFromIdAndClass(body, "lit-4", "referencia")
			?.toUpperCase()
			.replace("EVANGELHO", "")
			.replace("(", "")
			.replace(")", "")
			.trim();
		var auxEspaco = evangelho.split(" ");
		var auxVirgula = auxEspaco[1].split(",");

		var idEvangelista = retornaIdEvangelista(auxEspaco[0]);
		var capitulos = auxVirgula[0];
		auxVirgula.shift(); // remove primeiro item do array
		var versiculo = auxVirgula.toString().replace(/\./g, ";");

		return `${idEvangelista}#${capitulos}#${versiculo}`;
	} catch (error) {
		throw new Error(error);
	}
}

function GetValueFromIdAndClass(body, id, classTag) {
	try {
		var dom = new DOMParser().parseFromString(body, "text/html");
		var idElement = dom.getElementById(id);

		if (idElement != null) {
			var classDom = new DOMParser().parseFromString(
				idElement.innerHTML,
				"text/html"
			);
			var classElement = classDom.getElementsByClassName(classTag);

			if (classElement.length > 0) {
				return classElement[0].innerText;
			} else {
				return "";
			}
		} else {
			return "";
		}
	} catch (error) {
		return "";
	}
}

function retornaIdEvangelista(evangelista) {
	switch (evangelista.toUpperCase()) {
		case "JO":
			return 50;
		case "LC":
			return 49;
		case "MC":
			return 48;
		case "MT":
			return 47;
		default:
			return "";
	}
}
